import { getRestaurantCount } from '@/service/branch'
import { AsyncDataKeys, getAsyncDataKey } from '@/constants/async-data-keys'
import type { GetProductsReqParams } from '@/types/product'

export function useRestaurantCount(queryParams: ReadonlyRef<GetProductsReqParams>, { debounce = true } = {}) {
  const getRestaurantCountWithDebounce = useDebounceFn(getRestaurantCount, 300)
  const queryParamsKey = computed(() => JSON.stringify(queryParams.value))

  const asyncData = useLazyAsyncData(
    getAsyncDataKey(AsyncDataKeys.RESTAURANT_COUNT, [queryParamsKey.value]),
    async () => {
      const apiFunc = debounce ? getRestaurantCountWithDebounce : getRestaurantCount
      const {
        data: { total_count },
      } = await apiFunc(queryParams.value)
      return total_count
    },
    { watch: [queryParams], server: false }
  )

  return asyncData
}
